import moment from "moment-timezone";
import $ from "jquery"
import { Badge, Button, Col, OverlayTrigger, Row, Spinner, Tooltip } from "react-bootstrap";
import { ModalObsNF } from "./ModalObsNF";
import { useState } from "react";
import { Add } from "@material-ui/icons";
import { toast } from "react-toastify";
import { useLoading } from "../../hooks/useLoading";
import api from "../../services/api";
import { CloseModal } from "../../utils/closeModal";
import { ShowAlert } from "../../utils/showAlert";

let lstAux = [];

export function LojasTab({
  cds,
  users,
  onFilterCompanyByState,
  stores,
  productItemList,
  conferedLotesList,
  codigo_usuario,
  setBillingSuccessResponse,
  setlistItemProduto,
  setListLotesConferidos,
  setSeqItemListaDistinct
}) {
  const [showObsNFModal, setShowObsNFModal] = useState(false);
  const [obsNF, setObsNF] = useState('')

  const loadingBilling = useLoading()
  const loadingItemListLoja = useLoading()

  let spanNomeEmpresa = document.getElementById('spanNomeEmpresa');

  const handleClose = () => setShowObsNFModal(false);
  const handleShow = () => setShowObsNFModal(true);

  function firstUpperCase(phrase) {
    const str = phrase.toLowerCase();
    const arr = str.split(' ');
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }

    const str2 = arr.join(' ');
    return str2;
  }

  async function handleFaturar(isSubsidized = false) {
    try {
      let listas = '';
      let sequencia_pessoa = 0;
      var isConferido = false;

      if (productItemList.length === 0) {
        return toast.error('Não há produtos para serem faturados.');
      }

      let lst = productItemList.sort(function (a, b) {
        var x = a.sequencia_lista < b.sequencia_lista ? -1 : 1;
        return x;
      });

      let seq_lista_anterior = 0;
      lst.map(async (item) => {
        if (item.sequencia_lista !== seq_lista_anterior) {
          seq_lista_anterior = item.sequencia_lista;
          sequencia_pessoa = item.sequencia_pessoa;
          listas += item.sequencia_lista + ',';

          if (item.status_conferencia === 'Conferido') {
            isConferido = true;
          }
        }
      });

      const hasProdutoBonificado = productItemList.find(
        (produto) => produto.bonificado === 'S',
      );

      // isSubsidized falso por padrão e com bonificado 'S' abre o modal
      if (hasProdutoBonificado && !isSubsidized) {
        window.$('#modal-faturar-tipo').modal('show');
        return;
      }

      listas = listas ? listas.slice(0, -1) : '';

      if (listas.length > 200) {
        return toast.warning('Lista muito grande. Selecione um período menor.');
      }

      if (isConferido) {
        if (
          !window.confirm(
            'Existem produtos conferidos não liberados, deseja prosseguir?',
          )
        ) {
          return;
        }
      }

      if (listas) {
        loadingBilling.setLoading(true);

        //const urlToRequest = obsNF.length > 0 ? '/listaseparacao/faturaListaObs_v2' : '/listaseparacao/faturaLista_v2'

        const res = await api.post('/listaseparacao/faturaLista_v2', {
          seqCliente: sequencia_pessoa,
          listas: listas,
          chapaUsuario: codigo_usuario,
          bonificado: $('input[name="faturar-tipo"]:checked').val()
        });

        if (res.data !== undefined) {
          if (res.data.codResult == 0) {
            var toreturn =
              '<div><b>Número Pedido Vasilhame:</b> ' +
              (res.data.numero_pedido_vasilhame != null
                ? res.data.numero_pedido_vasilhame
                : '') +
              '</div>';
            toreturn +=
              '<div><b>Número Df Vasilhame:</b> ' +
              (res.data.Numero_Df_vasilhame != null
                ? res.data.Numero_Df_vasilhame
                : '') +
              '</div>';
            toreturn +=
              '<div><b>Número Pedido Produto:</b> ' +
              res.data.numero_pedido_produto +
              '</div>';
            toreturn +=
              '<div><b>Número Df Produto:</b> ' +
              res.data.Numero_DF_produto +
              '</div>';

            ShowAlert('Faturado com sucesso!', toreturn);
          } else if (res.data.resposta !== undefined) {
            toast.success(res.data.resposta);
          } else {
            setBillingSuccessResponse(res.data);
          }

          $('input[name="faturar-tipo"]')[1].checked = true;
          CloseModal();
          setObsNF('');
          window.$('#modal-faturar-success').modal('show');
        }
        loadingBilling.setLoading(false);
      } else {
        loadingBilling.setLoading(false);
        toast.error('Selecione uma empresa para faturar.');
      }

    } catch (err) {
      console.log(err);
      loadingBilling.setLoading(false);
      ShowAlert('Erro', 'Não foi possível concluir a operação.');
    }
  }

  async function FiltrarEmpresas() {
    $('#ddlUfs option').removeAttr('selected');
    $('#ddlUfs option').eq(0).attr('selected', 'selected');
    $('.btnEmpresa').hide();
    $(
      ".btnEmpresa:containsi('" + $('#txtFiltraEmpresa').val() + "')",
    ).slideDown('fast');
  }

  function handleItemListLoja(sequenciaPessoa, nomeEmpresa, info = '') {
    setlistItemProduto([]);
    setListLotesConferidos([]);
    loadingItemListLoja.setLoading(true);

    $('.btnEmpresa').removeClass('active-conferencia');
    $('.' + info).addClass('active-conferencia');

    let status = document.querySelector('#selStatusFixo2');
    let statusVal = status.value !== 'T' ? status.value : 'P,C,L,F,X';
    let centroDistibuicao = $('#centroDistribuicaoSelect2').val();
    let spanNomeProdutoConferido = document.querySelector(
      '#spanNomeProdutoConferido',
    );

    spanNomeEmpresa.innerHTML = '&nbsp;';
    spanNomeProdutoConferido.innerHTML = '&nbsp;';

    if ($('#centroDistribuicaoSelect2').val() == '') {
      alert('Selecione um centro de distribuição');
      return;
    }

    async function fetchData() {
      loadingItemListLoja.setLoading(true);
      const res = await api.post('/listaseparacao/produtoconferido_v2/', {
        numero_empresa: centroDistibuicao,
        sequencia_lista: null,
        sequencia_produto: null,
        sequencia_pessoa: sequenciaPessoa,
        data_inicial: moment($('#dataInicial2').val()).format('DD-MM-yyyy'),
        data_final: moment($('#dataFinal2').val()).format('DD-MM-yyyy'),
        status: statusVal,
        codigo_usuario:
          $('#inputTargetusuario').val() != ''
            ? $('#inputTargetusuario').val().split(' - ')[0]
            : null,
      });

      if (
        res.data.resposta === 'Item nao localizado' ||
        res.data === undefined
      ) {
        loadingItemListLoja.setLoading(false);
        $('#txtMsg').text('Nenhum item localizado');
        toast.error('Nenhum item localizado');
      } else {
        lstAux = res.data.sort(function (a, b) {
          var x = a.sequencia_lista < b.sequencia_lista ? -1 : 1;
          return x;
        });

        let lst = [];
        let seq_lista_anterior = 0;

        lstAux.forEach((item) => {
          if (item.sequencia_lista !== seq_lista_anterior) {
            seq_lista_anterior = item.sequencia_lista;
            lst.push(item);
          }
        });

        lstAux.forEach((item) => {
          item.prod_status = `${item.sequencia_produto}-${item.status_conferencia}`;
          item.descricao =
            item.sequencia_produto + ' - ' + firstUpperCase(item.descricao);

          switch (item.status_conferencia) {
            case 'F':
              item.status_conferencia = 'Finalizado';
              break;
            case 'L':
              item.status_conferencia = 'Liberado';
              break;
            case 'X':
              item.status_conferencia = 'Cancelado';
              break;
            case 'C':
              item.status_conferencia = 'Conferido';
              break;
            default:
              item.status_conferencia = 'Pendente';
          }
        });

        setSeqItemListaDistinct(
          lst.filter(
            (item) =>
              item.status_conferencia === 'Pendente' ||
              item.status_conferencia === 'Liberado' ||
              item.status_conferencia === 'Conferido',
          ),
        );

        lstAux = lstAux.filter(
          (item) => item.sequencia_pessoa === sequenciaPessoa,
        );

        spanNomeEmpresa.innerText = firstUpperCase(nomeEmpresa);

        lstAux = lstAux.sort(function (a, b) {
          var x =
            firstUpperCase(a.descricao) < firstUpperCase(b.descricao) ? -1 : 1;
          return x;
        });

        lstAux = lstAux.filter(
          (item) => item.sequencia_lote !== sequenciaPessoa,
        );

        var listaAuxiliar2 = [...lstAux];
        var findLista = [];
        var novaLista = [];
        // listaAuxiliar2 => lista de lotes por lista de produtos.

        for (var i = 0; i < listaAuxiliar2.length; i++) {
          var currentItem = listaAuxiliar2[i];

          // findLista => qtd de lotes em cada item de produtos.
          findLista = lstAux.filter(
            (item) =>
              item.sequencia_lista == currentItem.sequencia_lista &&
              item.sequencia_produto == currentItem.sequencia_produto &&
              item.status_conferencia == currentItem.status_conferencia &&
              item.codigo_usuario == currentItem.codigo_usuario &&
              item.bonificado == currentItem.bonificado,
          );

          if (findLista.length > 0) {
            var novoValor = 0;
            currentItem.quantidade_atendida = 0;

            for (var b = 0; b < findLista.length; b++) {
              novoValor += findLista[b].quantidade_atendida;
              var c = lstAux.indexOf(findLista[b]);
              lstAux.splice(c, 1);
            }
            currentItem.quantidade_atendida = novoValor;
            novaLista.push(currentItem);
          }
        }

        lstAux = [...listaAuxiliar2];
        /* lstAux => se torna a listagem final de produtos
          novaLista => é a lista de produtos agrupados*/
        setlistItemProduto(novaLista);
        loadingItemListLoja.setLoading(false);
      }
    }
    loadingItemListLoja.setLoading(false);

    fetchData();
  }

  function handleItemProduto(item, info = '') {
    $('.btnProduto').removeClass('active-conferencia');
    $('.' + info).addClass('active-conferencia');

    let spanNomeProdutoConferido = document.querySelector(
      '#spanNomeProdutoConferido',
    );
    spanNomeProdutoConferido.innerText = item.descricao;

    var a = lstAux.filter(
      (itemAux) =>
        item.sequencia_item_lista === itemAux.sequencia_item_lista &&
        itemAux.sequencia_lote !== 0 &&
        itemAux.status_conferencia === item.status_conferencia,
    );

    $('.input-lote').val('');
    setListLotesConferidos(a);

    if (a.length === 0) {
      //toast.error("Nenhum lote foi localizado.")
    }
  }


  async function handleSalvarLotes() {
    try {
      $('.ckbLoteConf:checked').each(async function () {

        const sequencia_lote = $(
          '.' + $(this).attr('data-sequenciaLote'),
        ).val();
        const sequencia_produto = $(this).attr('data-sequenciaProduto');
        const sequencia_lista = $(this).attr('data-sequenciaLista');
        const sequencia_pessoa = $(this).attr('data-sequenciaPessoa');
        const id_conferencia = $(this).attr('data-indiceConferencia');
        var status = $('.' + $(this).attr('data-status')).val();

        switch (status) {
          case 'Finalizado':
            status = 'F';
            break;
          case 'Liberado':
            status = 'L';
            break;
          case 'Cancelado':
            status = 'X';
            break;
          case 'Conferido':
            status = 'C';
            break;
          case 'Pendente':
            status = 'P';
            break;
          default:
            status = '';
        }

        const res = await api.post('/listaseparacao/alterarconferencia/', {
          sequencia_lista: sequencia_lista,
          status: status,
          codigo_usuario: codigo_usuario,
          sequencia_produto: sequencia_produto,
          sequencia_lote: sequencia_lote,
          id_conferencia: id_conferencia,
          sequencia_pessoa: sequencia_pessoa,
        });

        if (res !== undefined) {
          if (res.data.resposta !== undefined) {
            toast.error(res.data.resposta);
          }
          if (res.data[0].mensagem !== undefined) {
            if (res.data[0].numero_erro) {
              toast.error(res.data[0].mensagem);
            } else {
              toast.success(res.data[0].mensagem);
            }
          }
        } else {
          toast.error('Item não conferido.');
        }
      });
    } catch (ex) {
      toast.error('Não foi possível salvar os itens selecionados.');
    }
  }

  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="row bg-gray-light rounded p-3 mb-3">
            <div className="col-sm">
              <div className="form-group">
                <label>Centro de Distribuição</label>
                <select
                  id="centroDistribuicaoSelect2"
                  className="form-control"
                >
                  {cds.map((item, index) => (
                    <option key={index} value={item.numero_empresa}>
                      {item.nome_reduzido}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-sm">
              <div className="form-group">
                <label>Data Inicial</label>
                <input
                  type="date"
                  className="form-control"
                  id="dataInicial2"
                />
              </div>
            </div>

            <div className="col-sm">
              <div className="form-group">
                <label>Data Final</label>
                <input
                  type="date"
                  className="form-control"
                  id="dataFinal2"
                />
              </div>
            </div>

            <div className="col-sm">
              <div className="form-group">
                <label>Status </label>
                <select className="form-control" id="selStatusFixo2">
                  <option defaultValue value="P,C,L,F,X">
                    Todos
                  </option>
                  <option value="F">Finalizado</option>
                  <option value="L">Liberado</option>
                  <option value="X">Cancelado</option>
                  <option value="C">Conferido</option>
                  <option value="P">Pendente</option>
                </select>
              </div>
            </div>
            <div className="col-sm">
              <div className="form-group">
                <label>Conferente</label>

                <input
                  list="datalistTargetusuario"
                  autoComplete="off"
                  id="inputTargetusuario"
                  className="form-control"
                  placeholder="Entre com o nome do usuário"
                />
                <datalist
                  id="datalistTargetusuario"
                  className="form-control"
                  hidden
                >
                  {users.map((item) => (
                    <option key={item.username}>
                      {item.username} - {item.first_name}
                    </option>
                  ))}
                </datalist>
              </div>
            </div>
          </div>

          <div
            id="table-spinner"
            className="mb-3"
            style={{
              textAlign: 'center',
              position: 'absolute',
              zIndex: '9',
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(255,255,255,.5)',
              paddingTop: '110px',
            }}
          >
            <Spinner animation="border" variant="primary" />
          </div>

          <div className="row">
            <div className="col-sm-2">
              <h5>Empresa</h5>
              <select
                id="ddlUfs"
                className="form-control"
                onChange={onFilterCompanyByState}
              >
                <option value="0">Todos os estados</option>
                <option value="SP">SP</option>
                <option value="GO">GO</option>
                <option value="BA">BA</option>
                <option value="DF">DF</option>
              </select>
              <input
                type="search"
                id="txtFiltraEmpresa"
                className="form-control mt-2 mr-2"
                placeholder="Procurar empresa"
                onChange={FiltrarEmpresas}
              />
              <div
                className="faturamentoProd"
                style={{ height: '320px' }}
              >
                <table className="table table-striped table-hover">
                  <tbody>
                    {stores.map((item, index) => (
                      <tr
                        key={index}
                        className={'btnEmpresa btnEmpresa' + index}
                        data-uf={item.uf}
                      >
                        <td
                          style={{ cursor: 'pointer' }}
                          onClick={() =>
                            handleItemListLoja(
                              item.seqpessoa,
                              item.nome_reduzido,
                              'btnEmpresa' + index,
                            )
                          }
                        >
                          {item.nome_reduzido}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="col-sm-4">
              <div className="d-flex align-items-center gap-2">
                <h5>Produtos</h5>
                {loadingItemListLoja.isLoading ? (
                  <Spinner
                    className="ml-2"
                    animation="border"
                    variant="primary"
                    size="sm"
                  />
                ) : (
                  ''
                )}
              </div>
              <div className="faturamentoProd lotes">
                <Row >
                  <Col sm={8}
                    className="pl-3 pt-2 pb-2 text-bold"
                    id="spanNomeEmpresa"
                  >
                    &nbsp;
                  </Col>
                  {/*}
                  <Col sm={4} style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                    {productItemList.length > 0 ? (
                      <OverlayTrigger overlay={<Tooltip id="button-tooltip-obsNF">Incluir observação na NF.</Tooltip>}>
                        <Button
                          onClick={handleShow}
                          className="mr-2 p-1"
                          variant="info"
                        >
                          <Add />
                        </Button>
                      </OverlayTrigger>
                    ) : ''}

                  </Col>
                  {*/}
                </Row>
                <table className="table table-striped  table-hover">
                  <thead>
                    <tr>
                      <th>Lista</th>
                      <th>Descrição</th>
                      <th>Qtde</th>
                      <th>Status</th>
                      <th>Conferente</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productItemList.length === 0 ? (
                      <tr>
                        <td
                          id="txtMsg"
                          className="text-center"
                          colSpan="100"
                        >
                          Selecione uma empresa na lista ao lado
                        </td>
                      </tr>
                    ) : (
                      ''
                    )}

                    {productItemList.map((item, index) => (
                      <tr
                        key={index}
                        className={'btnProduto btnProduto' + index}
                        style={{ cursor: 'pointer' }}
                        onClick={() =>
                          handleItemProduto(
                            item,
                            'btnProduto' + index,
                          )
                        }
                      >
                        <td>{item.sequencia_lista}</td>
                        <td className="d-flex justify-content-between align-items-center">
                          {item.descricao}
                          {item.bonificado === 'S' ? (
                            <Badge
                              bg="primary"
                              title="Produto Bonificado"
                              className=" fs-4"
                            >
                              B
                            </Badge>
                          ) : (
                            ''
                          )}
                        </td>
                        <td>
                          {item.quantidade_atendida != 0
                            ? item.quantidade_atendida
                            : item.quantidade_conferida}
                        </td>
                        <td>{item.status_conferencia}</td>
                        <td>{item.nome_usuario}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="col-sm-6">
              <h5>Lotes</h5>
              <div className="faturamentoProd lotes">
                <div
                  className="pl-2 pt-2 pb-2 text-bold"
                  id="spanNomeProdutoConferido"
                >
                  &nbsp;
                </div>
                <table
                  className="table table-striped table-hover"
                  id="lotsTable"
                >
                  <thead>
                    <tr>
                      <th></th>
                      <th>Lote</th>
                      <th>Descrição</th>
                      <th>NF</th>
                      <th>Criação</th>
                      <th>Qtde</th>
                      <th>Tipo Lote</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {conferedLotesList.length === 0 ? (
                      <tr>
                        <td className="text-center" colSpan="100">
                          Selecione um produto na lista ao lado
                        </td>
                      </tr>
                    ) : (
                      ''
                    )}

                    {conferedLotesList.map((item, index) => (
                      <tr key={index}>
                        <td>
                          <input
                            type="checkbox"
                            className="checkbox ckbLoteConf"
                            data-status={'input-lote-status-' + index}
                            data-sequenciaProduto={
                              item.sequencia_produto
                            }
                            data-sequenciaPessoa={
                              item.sequencia_pessoa
                            }
                            data-sequenciaLote={'input-lote-' + index}
                            data-indiceConferencia={
                              item.indice_conferencia
                            }
                            data-sequenciaLista={item.sequencia_lista}
                          />
                        </td>
                        <td style={{ width: '15%' }}>
                          <input
                            style={{
                              border: 'none',
                              color: '#DD8500',
                              width: '100%',
                              backgroundColor: '#F5F5F5',
                            }}
                            type="number"
                            className={
                              'input-lote-' + index + ' input-lote'
                            }
                            value={item.sequencia_lote}
                          />
                        </td>
                        <td style={{ width: '30%' }}>
                          {item.descricao}
                        </td>
                        <td style={{ width: '10%' }}>
                          {item.numero_pedido}
                        </td>
                        <td style={{ width: '15%' }}>
                          {item.data_hora_registro != null
                            ? moment(item.data_hora_registro).format(
                              'DD/MM/yyyy',
                            )
                            : ''}
                        </td>
                        <td style={{ width: '10%' }}>
                          {item.quantidade_conferida}
                        </td>
                        <td style={{ width: '12%' }}>
                          {item.tipo_lote}
                        </td>
                        <td style={{ width: '10%' }}>
                          <span
                            className={
                              item.origem == 'N'
                                ? 'badge bg-blue'
                                : 'badge bg-red'
                            }
                            style={{
                              position: 'absolute',
                              'margin-top': '-7px',
                              marginLeft: '-5px',
                            }}
                            title="Origem (A = Avulso / N = Normal)"
                          >
                            {item.origem}
                          </span>
                          <select
                            id="selItemStatus"
                            className={'input-lote-status-' + index}
                            style={{
                              border: 'none',
                              color: '#DD8500',
                              backgroundColor: '#F5F5F5',
                            }}
                          >
                            <option
                              defaultValue
                              value={item.status_conferencia}
                            >
                              {item.status_conferencia}
                            </option>
                            <option value="Liberado">Liberado</option>
                            <option value="Cancelado">Cancelado</option>
                          </select>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-5">
              <button
                id="btnFaturar"
                className="form-control btn btn-primary float-right"
                style={{ margin: '3px' }}
                onClick={() => handleFaturar()}
                disabled={loadingBilling.isLoading}
              // data-bs-toggle="modal"
              >
                {loadingBilling.isLoading ? (
                  <Spinner
                    className="ml-2 mr-2"
                    animation="border"
                    variant="light"
                    size="sm"
                  />
                ) : (
                  'Faturar'
                )}
              </button>
            </div>
            <div className="col-sm-7">
              <button
                className="form-control btn btn-primary float-right"
                style={{ margin: '3px' }}
                onClick={handleSalvarLotes}
              >
                Salvar
              </button>
            </div>
          </div>
        </div>
      </div>

      {/*}       
      <ModalObsNF
        onCloseModal={handleClose}
        show={showObsNFModal}
        setObsNF={setObsNF}
        obsNF={obsNF}
      />
      {*/}
    </>
  )
}
